import { Alert } from '@mui/material';
import React from 'react';

interface IValidationErrorsAlertProps {
	messages: string[];
}

const ValidationErrorsAlert: React.FC<IValidationErrorsAlertProps> = ({
	messages
}) => (
	<Alert
		data-testid="validation-errors-alert"
		variant="outlined"
		severity="error"
		sx={{ whiteSpace: 'pre', textWrap: 'auto' }}
	>
		{messages?.join('\n')}
	</Alert>
);

export default ValidationErrorsAlert;
